(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/about.component.html":
/*!****************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/about.component.html ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"about\">\n  <h2>About</h2>\n  <p>\n    This app was designed and developed by\n    <a href=\"https://nicomv.com/\" title=\"Author Home page\">NicoMV</a> for the\n    <a\n      href=\"https://www.freecodecamp.org/learn/front-end-libraries/front-end-libraries-projects/build-a-javascript-calculator\"\n      >Free Code Camp's Front End Libraries Projects</a\n    >.\n  </p>\n  <p>\n    The source code of this app can be found by <a href=\"https://github.com/skaparate/fcc-calculator/\">clicking here</a>.<p>\n  <h3>Thanks</h3>\n  <ul>\n    <li>\n      <a href=\"https://github.com/josdejong/mathjs\" target=\"_blank\">MathJS</a>, used to evaluate\n      math expressions.\n    </li>\n    <li>\n      <a href=\"https://www.1001fonts.com/digital-7-font.html\" target=\"_blank\">Digital 7</a>, the\n      font used for the display.\n    </li>\n    <li>\n      <a href=\"https://freecodecamp.org/\" target=\"_blank\">Free Code Camp</a>, for helping people\n      on their developer careers.\n    </li>\n  </ul>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h1>My Basic Calculator</h1>\n<calculator></calculator>\n<about></about>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/calculator.component.html":
/*!*********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/calculator.component.html ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"calculator\">\n  <div class=\"calculator-wrapper\">\n    <div class=\"calculator-display-container\">\n      <div class=\"calculator-display calcular-display--expression\">\n        {{ expr }}\n      </div>\n      <div\n        id=\"display\"\n        class=\"calculator-display calculator-display--operation\"\n      >\n        {{ operation }}\n      </div>\n    </div>\n    <div class=\"calculator-buttons clearfix\">\n      <div class=\"calculator-actions\">\n        <button\n          class=\"calculator-button calculator-button--clear-all\"\n          (click)=\"onClearAll()\"\n          id=\"clear\"\n        >\n          AC\n        </button>\n        <button\n          class=\"calculator-button calculator-button--del calculator-button--backspace\"\n          value=\"del\"\n          (click)=\"onDelClick($event)\"\n        >\n          &larr;\n        </button>\n        <button\n          class=\"calculator-button calculator-button--add calculator-button--plus\"\n          value=\"+\"\n          id=\"add\"\n          (click)=\"onOperatorClick($event)\"\n        >\n          +\n        </button>\n        <button\n          class=\"calculator-button calculator-button--subtract calculator-button--minus\"\n          value=\"-\"\n          id=\"subtract\"\n          (click)=\"onOperatorClick($event)\"\n        >\n          -\n        </button>\n      </div>\n\n      <div class=\"calculator-numbers left\">\n        <button\n          *ngFor=\"let button of buttons\"\n          class=\"calculator-button calculator-button--{{ button.value }}\"\n          id=\"{{ button.id }}\"\n          data-value=\"{{ button.value }}\"\n          (click)=\"onButtonClick($event)\"\n        >\n          {{ button.value }}\n        </button>\n\n        <button\n          class=\"calculator-button calculator-button--decimal calculator-button--period\"\n          id=\"decimal\"\n          (click)=\"onDecimalClick()\"\n        >\n          .\n        </button>\n      </div>\n\n      <div class=\"calculator-operations left\">\n        <button\n          class=\"calculator-button calculator-button--divide\"\n          value=\"/\"\n          id=\"divide\"\n          (click)=\"onOperatorClick($event)\"\n        >\n          /\n        </button>\n        <button\n          class=\"calculator-button calculator-button--multiply\"\n          value=\"*\"\n          id=\"multiply\"\n          (click)=\"onOperatorClick($event)\"\n        >\n          *\n        </button>\n        <button\n          class=\"calculator-button calculator-button--mod\"\n          value=\"%\"\n          (click)=\"onOperatorClick($event)\"\n        >\n          %\n        </button>\n        <button\n          id=\"equals\"\n          class=\"calculator-button calculator-button--equals calculator-button--enter\"\n          (click)=\"onEqualsClick()\"\n        >\n          =\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/about.component.sass":
/*!**************************************!*\
  !*** ./src/app/about.component.sass ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".about {\n  width: 296px;\n  margin: 0 auto;\n  font-family: \"Arial\";\n}\n\np,\na {\n  font-size: 1.1rem;\n}\n\na {\n  color: #bf4e30;\n  text-decoration: none;\n}\n\nul {\n  padding-left: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi96ZWl0LzJjY2I5ZWZlL3NyYy9hcHAvYWJvdXQuY29tcG9uZW50LnNhc3MiLCJzcmMvYXBwL2Fib3V0LmNvbXBvbmVudC5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsWUFBQTtFQUNBLGNBQUE7RUFDQSxvQkFBQTtBQ0NGOztBRENBOztFQUVFLGlCQUFBO0FDRUY7O0FEQUE7RUFDRSxjQUFBO0VBQ0EscUJBQUE7QUNHRjs7QUREQTtFQUNFLGtCQUFBO0FDSUYiLCJmaWxlIjoic3JjL2FwcC9hYm91dC5jb21wb25lbnQuc2FzcyIsInNvdXJjZXNDb250ZW50IjpbIi5hYm91dFxuICB3aWR0aDogMjk2cHhcbiAgbWFyZ2luOiAwIGF1dG9cbiAgZm9udC1mYW1pbHk6ICdBcmlhbCdcblxucCxcbmFcbiAgZm9udC1zaXplOiAxLjFyZW1cblxuYVxuICBjb2xvcjogI2JmNGUzMFxuICB0ZXh0LWRlY29yYXRpb246IG5vbmVcblxudWxcbiAgcGFkZGluZy1sZWZ0OiAyMHB4XG4iLCIuYWJvdXQge1xuICB3aWR0aDogMjk2cHg7XG4gIG1hcmdpbjogMCBhdXRvO1xuICBmb250LWZhbWlseTogXCJBcmlhbFwiO1xufVxuXG5wLFxuYSB7XG4gIGZvbnQtc2l6ZTogMS4xcmVtO1xufVxuXG5hIHtcbiAgY29sb3I6ICNiZjRlMzA7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn1cblxudWwge1xuICBwYWRkaW5nLWxlZnQ6IDIwcHg7XG59Il19 */");

/***/ }),

/***/ "./src/app/about.component.ts":
/*!************************************!*\
  !*** ./src/app/about.component.ts ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let About = class About {
};
About = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'about',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./about.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/about.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./about.component.sass */ "./src/app/about.component.sass")).default]
    })
], About);
/* harmony default export */ __webpack_exports__["default"] = (About);


/***/ }),

/***/ "./src/app/app.component.sass":
/*!************************************!*\
  !*** ./src/app/app.component.sass ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("h1 {\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi96ZWl0LzJjY2I5ZWZlL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zYXNzIiwic3JjL2FwcC9hcHAuY29tcG9uZW50LnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQkFBQTtBQ0NGIiwiZmlsZSI6InNyYy9hcHAvYXBwLmNvbXBvbmVudC5zYXNzIiwic291cmNlc0NvbnRlbnQiOlsiaDFcbiAgdGV4dC1hbGlnbjogY2VudGVyXG4iLCJoMSB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'fcc-calculator';
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.sass */ "./src/app/app.component.sass")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _calculator_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./calculator.component */ "./src/app/calculator.component.ts");
/* harmony import */ var _about_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./about.component */ "./src/app/about.component.ts");






let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [_app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"], _calculator_component__WEBPACK_IMPORTED_MODULE_4__["default"], _about_component__WEBPACK_IMPORTED_MODULE_5__["default"]],
        imports: [_angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"]],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"]],
    })
], AppModule);



/***/ }),

/***/ "./src/app/calculator.component.sass":
/*!*******************************************!*\
  !*** ./src/app/calculator.component.sass ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".calculator {\n  width: 296px;\n  margin: 2rem auto;\n  border: 1px solid #c6ccb2;\n  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.75);\n  padding: 0.5rem;\n}\n\n.calculator-display {\n  font-family: \"Digital 7 Regular\";\n  font-size: 1.5rem;\n  padding: 1rem;\n  text-align: right;\n  background-color: #e5eafa;\n  color: black;\n  border: 1px solid #bac7f2;\n  box-shadow: inset 2px 2px 5px 0px rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n  min-height: 1rem;\n}\n\n.calculator-display:first-child {\n  border-bottom: none;\n}\n\n.calculator-buttons {\n  margin-top: 10px;\n}\n\n.calculator-button {\n  font-family: monospace;\n  font-size: 1.1rem;\n  margin: 5px;\n  border: none;\n  background-color: #e5eafa;\n  color: black;\n  width: 64px;\n  height: 32px;\n  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.75);\n  padding: 0;\n}\n\n.calculator-button:hover,\n.calculator-button :focus {\n  background-color: #bac7f2;\n}\n\n.calculator-button.active {\n  background-color: #bac7f2;\n}\n\n.calculator-button--clear-all {\n  color: #bf4e30;\n  font-weight: bold;\n}\n\n.calculator-button--0 {\n  width: 138px;\n}\n\n.calculator-numbers {\n  width: 222px;\n}\n\n.calculator-operations {\n  display: flex;\n  flex-direction: column;\n  width: 74px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi96ZWl0LzJjY2I5ZWZlL3NyYy9hcHAvY2FsY3VsYXRvci5jb21wb25lbnQuc2FzcyIsInNyYy9hcHAvY2FsY3VsYXRvci5jb21wb25lbnQuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7RUFDQSxpQkFBQTtFQUNBLHlCQUFBO0VBR0EsK0NBQUE7RUFDQSxlQUFBO0FDQ0Y7O0FEQ0E7RUFDRSxnQ0FBQTtFQUNBLGlCQUFBO0VBQ0EsYUFBQTtFQUNBLGlCQUFBO0VBQ0EseUJBQUE7RUFDQSxZQUFBO0VBQ0EseUJBQUE7RUFHQSxxREFBQTtFQUNBLGdCQUFBO0VBQ0EsZ0JBQUE7QUNFRjs7QURBQTtFQUNFLG1CQUFBO0FDR0Y7O0FEREE7RUFDRSxnQkFBQTtBQ0lGOztBREZBO0VBQ0Usc0JBQUE7RUFDQSxpQkFBQTtFQUNBLFdBQUE7RUFDQSxZQUFBO0VBQ0EseUJBQUE7RUFDQSxZQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7RUFHQSwrQ0FBQTtFQUNBLFVBQUE7QUNLRjs7QURKRTs7RUFFRSx5QkFBQTtBQ01KOztBREpBO0VBQ0UseUJBQUE7QUNPRjs7QURMQTtFQUNFLGNBQUE7RUFDQSxpQkFBQTtBQ1FGOztBRE5BO0VBQ0UsWUFBQTtBQ1NGOztBRFBBO0VBQ0UsWUFBQTtBQ1VGOztBRFJBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsV0FBQTtBQ1dGIiwiZmlsZSI6InNyYy9hcHAvY2FsY3VsYXRvci5jb21wb25lbnQuc2FzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYWxjdWxhdG9yXG4gIHdpZHRoOiAyOTZweFxuICBtYXJnaW46IDJyZW0gYXV0b1xuICBib3JkZXI6IDFweCBzb2xpZCAjYzZjY2IyXG4gIC13ZWJraXQtYm94LXNoYWRvdzogMnB4IDJweCA1cHggMHB4IHJnYmEoMCwwLDAsMC43NSlcbiAgLW1vei1ib3gtc2hhZG93OiAycHggMnB4IDVweCAwcHggcmdiYSgwLDAsMCwwLjc1KVxuICBib3gtc2hhZG93OiAycHggMnB4IDVweCAwcHggcmdiYSgwLDAsMCwwLjc1KVxuICBwYWRkaW5nOiAuNXJlbVxuXG4uY2FsY3VsYXRvci1kaXNwbGF5XG4gIGZvbnQtZmFtaWx5OiAnRGlnaXRhbCA3IFJlZ3VsYXInXG4gIGZvbnQtc2l6ZTogMS41cmVtXG4gIHBhZGRpbmc6IDFyZW1cbiAgdGV4dC1hbGlnbjogcmlnaHRcbiAgYmFja2dyb3VuZC1jb2xvcjogI2U1ZWFmYVxuICBjb2xvcjogYmxhY2tcbiAgYm9yZGVyOiAxcHggc29saWQgZGFya2VuKCNlNWVhZmEsIDEwJSlcbiAgLXdlYmtpdC1ib3gtc2hhZG93OiBpbnNldCAycHggMnB4IDVweCAwcHggcmdiYSgwLDAsMCwwLjc1KVxuICAtbW96LWJveC1zaGFkb3c6IGluc2V0IDJweCAycHggNXB4IDBweCByZ2JhKDAsMCwwLDAuNzUpXG4gIGJveC1zaGFkb3c6IGluc2V0IDJweCAycHggNXB4IDBweCByZ2JhKDAsMCwwLDAuNzUpXG4gIG92ZXJmbG93OiBoaWRkZW5cbiAgbWluLWhlaWdodDogMXJlbVxuXG4uY2FsY3VsYXRvci1kaXNwbGF5OmZpcnN0LWNoaWxkXG4gIGJvcmRlci1ib3R0b206IG5vbmVcblxuLmNhbGN1bGF0b3ItYnV0dG9uc1xuICBtYXJnaW4tdG9wOiAxMHB4XG5cbi5jYWxjdWxhdG9yLWJ1dHRvblxuICBmb250LWZhbWlseTogbW9ub3NwYWNlXG4gIGZvbnQtc2l6ZTogMS4xcmVtXG4gIG1hcmdpbjogNXB4XG4gIGJvcmRlcjogbm9uZVxuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTVlYWZhXG4gIGNvbG9yOiBibGFja1xuICB3aWR0aDogNjRweFxuICBoZWlnaHQ6IDMycHhcbiAgLXdlYmtpdC1ib3gtc2hhZG93OiAycHggMnB4IDVweCAwcHggcmdiYSgwLDAsMCwwLjc1KVxuICAtbW96LWJveC1zaGFkb3c6IDJweCAycHggNXB4IDBweCByZ2JhKDAsMCwwLDAuNzUpXG4gIGJveC1zaGFkb3c6IDJweCAycHggNXB4IDBweCByZ2JhKDAsMCwwLDAuNzUpXG4gIHBhZGRpbmc6IDBcbiAgJjpob3ZlcixcbiAgOmZvY3VzXG4gICAgYmFja2dyb3VuZC1jb2xvcjogZGFya2VuKCNlNWVhZmEsIDEwJSlcblxuLmNhbGN1bGF0b3ItYnV0dG9uLmFjdGl2ZVxuICBiYWNrZ3JvdW5kLWNvbG9yOiBkYXJrZW4oI2U1ZWFmYSwgMTAlKVxuXG4uY2FsY3VsYXRvci1idXR0b24tLWNsZWFyLWFsbFxuICBjb2xvcjogI2JmNGUzMFxuICBmb250LXdlaWdodDogYm9sZFxuXG4uY2FsY3VsYXRvci1idXR0b24tLTBcbiAgd2lkdGg6IDEzOHB4XG5cbi5jYWxjdWxhdG9yLW51bWJlcnNcbiAgd2lkdGg6IDIyMnB4XG5cbi5jYWxjdWxhdG9yLW9wZXJhdGlvbnNcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uXG4gIHdpZHRoOiA3NHB4XG4iLCIuY2FsY3VsYXRvciB7XG4gIHdpZHRoOiAyOTZweDtcbiAgbWFyZ2luOiAycmVtIGF1dG87XG4gIGJvcmRlcjogMXB4IHNvbGlkICNjNmNjYjI7XG4gIC13ZWJraXQtYm94LXNoYWRvdzogMnB4IDJweCA1cHggMHB4IHJnYmEoMCwgMCwgMCwgMC43NSk7XG4gIC1tb3otYm94LXNoYWRvdzogMnB4IDJweCA1cHggMHB4IHJnYmEoMCwgMCwgMCwgMC43NSk7XG4gIGJveC1zaGFkb3c6IDJweCAycHggNXB4IDBweCByZ2JhKDAsIDAsIDAsIDAuNzUpO1xuICBwYWRkaW5nOiAwLjVyZW07XG59XG5cbi5jYWxjdWxhdG9yLWRpc3BsYXkge1xuICBmb250LWZhbWlseTogXCJEaWdpdGFsIDcgUmVndWxhclwiO1xuICBmb250LXNpemU6IDEuNXJlbTtcbiAgcGFkZGluZzogMXJlbTtcbiAgdGV4dC1hbGlnbjogcmlnaHQ7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlNWVhZmE7XG4gIGNvbG9yOiBibGFjaztcbiAgYm9yZGVyOiAxcHggc29saWQgI2JhYzdmMjtcbiAgLXdlYmtpdC1ib3gtc2hhZG93OiBpbnNldCAycHggMnB4IDVweCAwcHggcmdiYSgwLCAwLCAwLCAwLjc1KTtcbiAgLW1vei1ib3gtc2hhZG93OiBpbnNldCAycHggMnB4IDVweCAwcHggcmdiYSgwLCAwLCAwLCAwLjc1KTtcbiAgYm94LXNoYWRvdzogaW5zZXQgMnB4IDJweCA1cHggMHB4IHJnYmEoMCwgMCwgMCwgMC43NSk7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIG1pbi1oZWlnaHQ6IDFyZW07XG59XG5cbi5jYWxjdWxhdG9yLWRpc3BsYXk6Zmlyc3QtY2hpbGQge1xuICBib3JkZXItYm90dG9tOiBub25lO1xufVxuXG4uY2FsY3VsYXRvci1idXR0b25zIHtcbiAgbWFyZ2luLXRvcDogMTBweDtcbn1cblxuLmNhbGN1bGF0b3ItYnV0dG9uIHtcbiAgZm9udC1mYW1pbHk6IG1vbm9zcGFjZTtcbiAgZm9udC1zaXplOiAxLjFyZW07XG4gIG1hcmdpbjogNXB4O1xuICBib3JkZXI6IG5vbmU7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlNWVhZmE7XG4gIGNvbG9yOiBibGFjaztcbiAgd2lkdGg6IDY0cHg7XG4gIGhlaWdodDogMzJweDtcbiAgLXdlYmtpdC1ib3gtc2hhZG93OiAycHggMnB4IDVweCAwcHggcmdiYSgwLCAwLCAwLCAwLjc1KTtcbiAgLW1vei1ib3gtc2hhZG93OiAycHggMnB4IDVweCAwcHggcmdiYSgwLCAwLCAwLCAwLjc1KTtcbiAgYm94LXNoYWRvdzogMnB4IDJweCA1cHggMHB4IHJnYmEoMCwgMCwgMCwgMC43NSk7XG4gIHBhZGRpbmc6IDA7XG59XG4uY2FsY3VsYXRvci1idXR0b246aG92ZXIsXG4uY2FsY3VsYXRvci1idXR0b24gOmZvY3VzIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2JhYzdmMjtcbn1cblxuLmNhbGN1bGF0b3ItYnV0dG9uLmFjdGl2ZSB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNiYWM3ZjI7XG59XG5cbi5jYWxjdWxhdG9yLWJ1dHRvbi0tY2xlYXItYWxsIHtcbiAgY29sb3I6ICNiZjRlMzA7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4uY2FsY3VsYXRvci1idXR0b24tLTAge1xuICB3aWR0aDogMTM4cHg7XG59XG5cbi5jYWxjdWxhdG9yLW51bWJlcnMge1xuICB3aWR0aDogMjIycHg7XG59XG5cbi5jYWxjdWxhdG9yLW9wZXJhdGlvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICB3aWR0aDogNzRweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/calculator.component.ts":
/*!*****************************************!*\
  !*** ./src/app/calculator.component.ts ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var mathjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mathjs */ "./node_modules/mathjs/main/esm/index.js");



let Calculator = class Calculator {
    constructor() {
        this.operation = '0';
        this.nums = Array.from(Array(10), (x, i) => i);
        this.buttons = [];
        this.operators = ['-', '+', '*', '/', '%'];
        this.expr = '0';
        this.result = '';
        let code = [48, 96];
        const names = [
            'zero',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
        ];
        this.nums.forEach(i => {
            this.buttons.push({
                value: i,
                id: names[i],
                code: [code[0], code[1]],
            });
            code[0]++;
            code[1]++;
        });
        this.buttons = this.buttons.reverse();
    }
    ngOnInit() {
        document.addEventListener('keyup', this.handleKeyPress);
    }
    handleNumber(value) {
        if (this.result) {
            this.expr = '';
            this.result = '';
            this.operation = '';
        }
        if (this.operation === '0') {
            this.operation = value;
            this.expr = value;
        }
        else {
            if (this.operation.length >= 1) {
                if (this.operation.startsWith('0') &&
                    this.operation[1] !== '.' &&
                    value === '0') {
                    return;
                }
            }
            this.operation += value;
            this.expr += value;
        }
    }
    handleKeyPress(event) {
        const code = event.code;
        console.debug('Event:', event);
        let key;
        if (code === 'BracketRight') {
            key = 'plus';
            if (event.shiftKey) {
                key = 'multiply';
            }
        }
        else if (code === 'Digit5' && event.shiftKey) {
            key = 'mod';
        }
        else if (code === 'KeyC') {
            key = 'clear-all';
        }
        else if (code === 'Slash') {
            key = 'minus';
        }
        else {
            key = code.toLowerCase().replace(/(numpad|digit|key)/, '');
        }
        const element = document.querySelector(`.calculator-button--${key}`);
        if (element) {
            element.classList.add('active');
            element.click();
            const handle = setTimeout(() => {
                element.classList.remove('active');
                clearTimeout(handle);
            }, 100);
        }
    }
    clear(clearResult = true) {
        this.operation = '0';
        this.expr = '0';
        if (clearResult) {
            this.result = '';
        }
    }
    onClearAll() {
        this.clear();
    }
    onButtonClick(event) {
        const value = event.target.value;
        console.debug('Button value:', value);
        this.handleNumber(value);
    }
    /**
     * Handles the operator button clicks.
     *
     * @param event The event sent from the button.
     */
    onOperatorClick(event) {
        const value = event.target.value;
        console.debug('Operator click:', value);
        if (this.result) {
            this.expr = this.result;
            this.result = '';
        }
        const canAdd = this.canAddOperator(value);
        if (canAdd === 1) {
            console.debug('Appending operator');
            this.expr += value;
        }
        else if (canAdd === 0) {
            console.debug('Replacing operator');
            this.expr = this.expr.slice(0, -1) + value;
        }
        else {
            this.expr = this.expr.slice(0, -2) + value;
        }
        this.operation = value;
    }
    /**
     * Handles the decimal button click.
     */
    onDecimalClick() {
        const dot = '.';
        if (this.operation.includes(dot)) {
            return;
        }
        this.operation += dot;
        this.expr += dot;
    }
    /**
     * Handles the equals button click.
     */
    onEqualsClick() {
        this.operation = '';
        this.expr = this.expr.replace(/([\-\s+\/\*%]*$|(=\d+))/g, '');
        this.result = Object(mathjs__WEBPACK_IMPORTED_MODULE_2__["evaluate"])(this.expr);
        this.expr = `${this.expr}=${this.result}`;
        this.operation = this.result;
    }
    /**
     * Handles the delete button click.
     */
    onDelClick() {
        // Disable the delete action if there is an equal sign
        if (this.expr.indexOf('=') >= 0) {
            return;
        }
        // Remove the last character of the current operation, if any.
        if (this.operation.length > 0) {
            this.operation = this.operation.slice(0, -1);
        }
        if (this.expr.length > 0) {
            // Remove the last character of the expression
            this.expr = this.expr.slice(0, -1);
            if (this.expr.length === 0) {
                // If the expression is empty, clear all.
                this.clear(false);
            }
        }
    }
    /**
     * Checks if the operator can be added or not.
     * Restrictions:
     *
     * - No more than two consecutive operators
     * - The only operator that can be repeated twice is minus
     * - Any operator can be followed by the minus.
     * @param val The val to check.
     */
    canAddOperator(val) {
        const lastExpression = this.expr[this.expr.length - 1];
        const lastIsOperator = this.isOperator(lastExpression);
        if (!lastIsOperator ||
            (val === '-' &&
                lastIsOperator &&
                !this.isOperator(this.expr[this.expr.length - 2]))) {
            return 1;
        }
        else if (this.isOperator(this.expr[this.expr.length - 2])) {
            return -1;
        }
        return 0;
    }
    /**
     * Checks if a string is a operator.
     *
     * @param operator The string to check.
     */
    isOperator(operator) {
        return this.operators.includes(operator);
    }
};
Calculator = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'calculator',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./calculator.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/calculator.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./calculator.component.sass */ "./src/app/calculator.component.sass")).default]
    })
], Calculator);
/* harmony default export */ __webpack_exports__["default"] = (Calculator);


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
localStorage.setItem('project_selector', 'javascript-calculator');
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /zeit/2ccb9efe/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map